import VideoPlayerEnded from './VideoPlayerEnded'

export default VideoPlayerEnded
// eslint-disable-next-line import/export
export * from './VideoPlayerEnded'
